import React from 'react'
import { Outlet } from 'react-router-dom'

const Admission = () => {
  return (
    <><Outlet /></>
  )
}

export default Admission